import { Params, useParams } from "react-router-dom";
import { isTaskAssortmentMatrix } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { AssortmentMatrixPage } from "./AssortmentMatrixPage";

interface AssortmentMatrixParams extends Params {
    pointId: string;
    taskId: string;
}

const AssortmentMatrix = () => {
    const { pointId = "", taskId = "" } = useParams<AssortmentMatrixParams>();

    const currentPoint = usePointSelector(pointId);
    const currentTask = useTaskSelector(pointId, taskId);

    if (!currentPoint || !currentTask || !isTaskAssortmentMatrix(currentTask)) {
        return <NotFound />;
    }

    return <AssortmentMatrixPage task={currentTask} point={currentPoint} />;
};

export default AssortmentMatrix;
